import { colors } from "oolib";
import { transition } from "oolib/dist/themes/mixins/transitions";
import styled, { css } from "styled-components";
import { getPrimaryColor10, getPrimaryColor100 } from "oolib/dist/utilsOolib";
import { globalHoverOnWhiteBG } from "oolib/dist/globalStyles/globalVariables";

export const StyledSimpleTable = styled.div`
  border-top: 1px solid ${colors.greyColor10};

  border-left: 1px solid ${colors.greyColor10};
`;
export const StyledSimpleTableRow = styled.div`
  min-height: 4rem;
  position: relative;
  display: flex;
  ${transition("background-color")};
  /* background-color: ${({ rowIdx }) =>
    rowIdx % 2 === 1 ? colors.white : colors.greyColor3}; */
  ${({ actionsActiveOnRow, rowIdx, theme }) =>
    actionsActiveOnRow === rowIdx &&
    css`
      &::before {
        content: "";
        position: absolute;
        width: calc(100% - 1px);
        height: calc(100% - 1px);
        outline: 1px solid ${getPrimaryColor100(theme?.colors)};
        border: 1px solid ${getPrimaryColor100(theme?.colors)};
        z-index: 1;
      }
    `}
`;

const genActiveColBorder = ({
  actionsActiveOnCol,
  colIdx,
  rowIdx,
  totRows,
  theme,
}) => {
  const isActiveCol = actionsActiveOnCol === colIdx;
  const isFirstRow = rowIdx === 0;
  const isLastRow = rowIdx === totRows - 1;
  return (
    isActiveCol &&
    css`
      &::before {
        content: "";
        position: absolute;
        left: -1px;
        top: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        border: 2px solid ${getPrimaryColor100(theme?.colors)};
        z-index: 1;
        ${isFirstRow
          ? css`
              border-bottom: none;
            `
          : !isFirstRow && !isLastRow
          ? css`
              border-bottom: none;
              border-top: none;
            `
          : isLastRow &&
            css`
              border-top: none;
            `}
      }
    `
  );
};

const tableCellStyling = css`
  min-height: 4rem;
  position: relative;
  border-right: 1px solid ${colors.greyColor10};
  border-bottom: 1px solid ${colors.greyColor10};
  ${transition("background-color")};

  ${({ readOnly }) =>
    readOnly &&
    css`
      cursor: default !important;
    `};

  ${({
    readOnly,
    theme,
    actionsActiveOnRow,
    actionsActiveOnCol,
    rowIdx,
    totRows,
    colIdx,
  }) =>
    !readOnly &&
    css`
      ${globalHoverOnWhiteBG};

      ${!actionsActiveOnRow &&
      !actionsActiveOnCol &&
      css`
        :focus-within {
          &::before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            outline: 1px solid ${getPrimaryColor100(theme?.colors)};
            border: 1px solid ${getPrimaryColor100(theme?.colors)};
          }
          background-color: ${colors.none};
        }
      `}

      ${genActiveColBorder({
        theme,
        actionsActiveOnCol,
        rowIdx,
        totRows,
        colIdx,
      })}
    `}
`;

export const StyledSimpleTableCell = styled.div`
  ${tableCellStyling}
`;

export const StyledSimpleTableHeaderCell = styled.div`
  ${tableCellStyling}
  .public-DraftEditor-content {
    font-weight: 600;
  }
  background-color: ${colors.greyColor3};
  border-right: 2px solid ${colors.greyColor10};
`;

export const StyledSimpleTableHeader = styled.div`
  .public-DraftEditor-content {
    font-weight: 600;
  }
  background-color: ${colors.greyColor3};
  border-bottom: 2px solid ${colors.greyColor10};
`;
